export default "__VITE_ASSET__Dkx4RQjo__"